import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, Field, FieldArray, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import find from "lodash.find";
import isNumber from "lodash.isnumber";
import isNil from "lodash.isnil";
import getDefaultValues from "../components/form/getDefaultValues";
import {
  Responsive,
  Toolbar,
  setSidebarVisibility,
  showNotification,
  GET_ONE
} from "admin-on-rest"; //GET_LIST ,
import {
  RestJsonSKUFilter,
  RestApiReSendEmail,
  RestClient
} from "../restClient"; //
import "./index.css";
import FlatButton from "material-ui/FlatButton";
import ContentAdd from "material-ui/svg-icons/content/add-circle";
import ActionDelete from "material-ui/svg-icons/action/highlight-off";
import Divider from "material-ui/Divider";
import { renderMultiTextField, renderTextFieldView } from "./OrderFormField";
import {
  Table,
  TableBody,
  TableFooter,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { TextField } from "redux-form-material-ui";
import {
  DivContainer,
  DivTotal,
  DivFieldTotal,
  DivOrderTotal,
  DivSubTotal
} from "./styled";

import {
  renderTitle,
  renderField,
  renderCustomer,
  renderItemList
} from "./edit/EditOrderField";
import { ValuesForm } from "../components";

class EditOrderForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      // insert customer name with first name and lastname;
      //values.customer_info.name = values.customer_info.first_name +' ' + values.customer_info.last_name;
      this.props.save(values, redirect);
    });
  constructor(props) {
    super(props);

    this.state = {
      isShow: false,
      dataItems: [],
      isLoadItems: true,
      subtotal: isNil(props.record.amounts.subtotal)
        ? 0
        : props.record.amounts.subtotal,
      customTotal: isNil(props.record.amounts.custom)
        ? 0
        : props.record.amounts.custom,
      total_items: isNil(props.record.amounts.total_items)
        ? 0
        : props.record.amounts.total_items,
      custom: 0,
      coupon: 0,
      shipping: isNil(props.record.amounts.shipping)
        ? 0
        : props.record.amounts.shipping,
      interest: isNil(props.record.amounts.interest)
        ? 0
        : props.record.amounts.interest,
      fee: isNil(props.record.amounts.fee) ? 0 : props.record.amounts.fee,
      total: isNil(props.record.amounts.total) ? 0 : props.record.amounts.total,
      resetCustomerInfo: false,
      isResend: false,
      fullname: "",
      marketer_id: 0
    };
  }
  componentWillMount() {
    //console.log(this.props.record);
    // this.getProductSku();
    // this.props.setSidebarVisibility(false);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.marketer_id !== 0 &&
      this.state.marketer_id !== nextProps.marketer_id
    ) {
      this.getMarketer(nextProps.marketer_id);
    }
  }

  getMarketer = marketer_id => {
    RestClient(GET_ONE, "marketers", { id: marketer_id })
      .then(items => {
        if (items && items.data) {
          const fullname =
            items.data.first_name && items.data.last_name
              ? `${items.data.first_name} ${items.data.last_name}`
              : "";
          this.setState({
            fullname: fullname,
            marketer_id: marketer_id
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  getProductSku = () => {
    // RestClient(GET_LIST, 'products/sku',{
    // pagination: { page: 1, perPage: 500 },
    // sort: { field: 'sku', order: 'ASC' },
    // filter:{ }})
    // .then((items) => {
    //   console.log(items)
    //   this.setState({dataItems:items.data});
    // })
    // .catch((e) => {
    //   console.error(e);
    // })
    RestJsonSKUFilter("abc")
      .then(response => {
        return response.json();
      })
      .then(items => {
        this.setState({ dataItems: items });
      })
      .catch(e => {
        console.error(e);
      });
  };

  onChangeItemSKU = (event, value, index) => {
    let data = find(this.state.dataItems, { sku: value });
    let datatotal = this.props.items[index].qty * data.discountedPrice;
    this.props.items[index].available = data.available;
    this.props.items[index].discountedPrice = data.discountedPrice;
    this.props.items[index].id = data.id;
    //this.props.items[index].qty = 0;
    if (isNumber(datatotal)) {
      this.props.items[index].subtotal = datatotal;
      this.handleItemsTotal();
    }
  };
  onChangeItemQuantity = (event, value, index) => {
    const value1 = parseFloat(value);
    if (isNumber(value1)) {
      this.props.items[index].qty = value1;
      this.props.items[index].subtotal = this.props.items[index].price * value1;
      this.handleItemsTotal();
    }
  };

  handleItemsTotal = () => {
    let subtotal = 0;
    let total_items = 0;
    let customItem = 0;
    if (this.props.customs != null && this.props.customs.length > 0) {
      customItem = this.props.customs.length;
    }
    if (this.props.items != null && this.props.items.length > 0) {
      for (let i = 0; i < this.props.items.length; i++) {
        if (!isNaN(this.props.items[i].subtotal)) {
          subtotal = this.props.items[i].subtotal + subtotal;
        }
      }
      total_items = this.props.items.length + customItem;
    } else {
      total_items = customItem;
    }

    let customTotal = this.state.customTotal;
    let total = customTotal + subtotal;

    this.setState({
      subtotal: subtotal,
      total: total
    });

    this.props.amounts.total = total;
    this.props.amounts.subtotal = subtotal;
    this.props.amounts.total_items = total_items;
  };

  renderCustomFieldsSmall = (customs, index, fields) => (
    <TableRow key={index}>
      <TableRowColumn style={{ height: "100%", whiteSpace: "normal" }}>
        <Field
          floatingLabelText="Variable"
          name={`${customs}.variable`}
          component={TextField}
          placeholder="variable"
        />
        <Field
          floatingLabelText="Quantity"
          name={`${customs}.qty`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomQty(event, value, index)
          }
          placeholder="qty"
        />
        <Field
          floatingLabelText="Price"
          name={`${customs}.price`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomPrice(event, value, index)
          }
          placeholder="price"
        />
        <Field
          floatingLabelText="Subtotal"
          label="Subtotal"
          name={`${customs}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="total"
        />
        <div style={{ textAlign: "right", marginBottom: 10 }}>
          <FlatButton
            primary
            label="Remove"
            onClick={() => fields.remove(index)}
            icon={<ActionDelete />}
          />
        </div>
      </TableRowColumn>
    </TableRow>
  );
  renderCustomFields = (customs, index, fields) => (
    <TableRow key={index}>
      <TableRowColumn>
        <Field
          label=""
          name={`${customs}.variable`}
          component={TextField}
          placeholder="variable"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${customs}.qty`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomQty(event, value, index)
          }
          placeholder="qty"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${customs}.price`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomPrice(event, value, index)
          }
          placeholder="price"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 80 }}>
        <Field
          label=""
          name={`${customs}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="total"
        />
      </TableRowColumn>
      <TableRowColumn style={{ textAlign: "right", width: 30 }}>
        <FlatButton
          primary
          label=""
          onClick={() => fields.remove(index)}
          icon={<ActionDelete />}
        />
      </TableRowColumn>
    </TableRow>
  );
  renderCustomList = ({ fields }) => {
    return (
      <Responsive
        small={
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              {fields.map(this.renderCustomFieldsSmall.bind())}
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <FlatButton
                    primary
                    label="add Custom line"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        }
        medium={
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              {fields.map(this.renderCustomFields.bind())}
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <FlatButton
                    primary
                    label="add Custom line"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        }
      />
    );
  };
  onChangeCustomQty = (event, value, index) => {
    if (!this.props.customs[index].subtotal) {
      this.props.customs[index].subtotal = 0;
    }
    this.props.customs[index].qty = value;
    this.props.customs[index].subtotal =
      this.props.customs[index].price * value;
    this.handleCustomTotal();
  };

  onChangeCustomPrice = (event, value, index) => {
    this.props.customs[index].price = value;
    this.props.customs[index].subtotal = this.props.customs[index].qty * value;
    this.handleCustomTotal();
  };

  handleCustomTotal = () => {
    let customTotal = 0;
    let total_items = 0;
    let itemsTotal = 0;
    if (this.props.items != null && this.props.items.length > 0) {
      itemsTotal = this.props.items.length;
    }
    if (this.props.customs != null && this.props.customs.length > 0) {
      for (let i = 0; i < this.props.customs.length; i++) {
        if (!isNaN(this.props.customs[i].subtotal)) {
          customTotal = this.props.customs[i].subtotal + customTotal;
          // console.log("masuk ==>"+customTotal);
        }
      }
      total_items = itemsTotal + this.props.customs.length;
    } else {
      total_items = itemsTotal;
    }

    let subtotal = this.state.subtotal;
    let total = subtotal + customTotal;
    this.setState({
      customTotal: customTotal,
      total: total
    });
    this.props.amounts.total = total;
    this.props.amounts.custom = customTotal;
    this.props.amounts.total_items = total_items;
  };
  reSendEmail = () => {
    const { record, showNotification } = this.props;
    if (record && record.id) {
      this.setState({
        isResend: true
      });
      RestApiReSendEmail(record.id)
        .then(response => {
          return response.json();
        })
        .then(items => {
          this.setState({
            isResend: false
          });
          showNotification("resources.actions.error.emailSent");
        })
        .catch(e => {
          this.setState({
            isResend: false
          });
          showNotification("resources.actions.error.try");
          // console.error(e);
        });
    }
  };
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar,
      permissions
    } = this.props;
    return (
      <div>
        <form className="simple-form">
          <DivContainer>
            {renderCustomer(
              children,
              record,
              permissions,
              this.reSendEmail,
              this.state.isResend,
              this.state.fullname
            )}
            {renderTitle("Items")}
            <Divider />
            <div>
              <FieldArray
                name="items"
                component={renderItemList}
                permissions={permissions}
                onChangeItemSKU={this.onChangeItemSKU.bind(this)}
                onChangeItemQuantity={this.onChangeItemQuantity.bind(this)}
              />
            </div>
            {/* {this.props.permissions==="Admin" && <div>
              {renderTitle('Customs Line')}
              <Divider />
              <FieldArray name="customs" component={this.renderCustomList} />
            </div>} */}
            <DivTotal>
              <DivFieldTotal>
                <Field
                  name="note"
                  component={renderMultiTextField}
                  label="Note"
                />
                {React.Children.map(
                  children,
                  input =>
                    input &&
                    input.props.source === "tracking" &&
                    renderField({ input, resource, record, basePath })
                )}
              </DivFieldTotal>
              <DivOrderTotal>
                <Divider />
                <DivSubTotal>
                  <div>Subtotal </div>
                  <div>{this.state.subtotal} </div>
                </DivSubTotal>
                <DivSubTotal>
                  <div>Custom </div>
                  <div>{this.state.customTotal}</div>
                </DivSubTotal>
                <DivSubTotal>
                  <div>Coupon </div>
                  <div>{this.state.coupon}</div>
                </DivSubTotal>
                <DivSubTotal>
                  <div> Shipping </div>
                  <div>{this.state.shipping}</div>
                </DivSubTotal>
                {this.state.interest > 0 && (
                  <DivSubTotal>
                    <div> Interest </div>
                    <div>{this.state.interest}</div>
                  </DivSubTotal>
                )}
                {this.state.interest > 0 && (
                  <DivSubTotal>
                    <div> Processing Fee </div>
                    <div>{this.state.fee}</div>
                  </DivSubTotal>
                )}
                <DivSubTotal>
                  <div>Total </div>
                  <div>{this.state.total}</div>
                </DivSubTotal>
              </DivOrderTotal>
            </DivTotal>
          </DivContainer>
          <ValuesForm isDebug={false} formName={"record-form"} />
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}

EditOrderForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  permissions: PropTypes.string,
  showNotification: PropTypes.func
};

EditOrderForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const issued_at = selector(state, "issued_at");
      const customer_id = selector(state, "customer_id");
      const customer_info = selector(state, "customer_info");
      const items = selector(state, "items");
      const customs = selector(state, "customs");
      const amounts = selector(state, "amounts");
      const marketer_id = selector(state, "marketer_id");

      return {
        initialValues: getDefaultValues(state, props),
        issued_at,
        customer_id,
        customer_info,
        items,
        customs,
        amounts,
        marketer_id
      };
    },
    { setSidebarVisibility, showNotification }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(EditOrderForm);



// WEBPACK FOOTER //
// ./src/orders/EditOrderForm.js